import { Practice } from "../types";

const practices: Practice = {
  C1056: {
    id: "C1056",
    label: "partial rejection of the Old Testament",
    aggregation_level2: "against Church's authoritative writings",
    aggregation_level1: "against Church's tradition",
  },
  C2093: {
    id: "C2093",
    label: "rejection of writings of the doctors of the Church",
    aggregation_level2: "against Church's authoritative writings",
    aggregation_level1: "against Church's tradition",
  },
  C2222: {
    id: "C2222",
    label: "rejection of the Old Testament",
    aggregation_level2: "against Church's authoritative writings",
    aggregation_level1: "against Church's tradition",
  },
  C1815: {
    id: "C1815",
    label: "rejection of infant baptism",
    aggregation_level2: "against Church's practices",
    aggregation_level1: "against Church's tradition",
  },
  C1167: {
    id: "C1167",
    label: "rejection of fasting",
    aggregation_level2: "against Church's practices",
    aggregation_level1: "against Church's tradition",
  },
  C2096: {
    id: "C2096",
    label: "Eucharist cannot be consecrated by an unworthy priest",
    aggregation_level2: "against priestly exclusivity",
    aggregation_level1: "against Church/society",
  },
  C2088: {
    id: "C2088",
    label: "priests do not have the power to bind or loose",
    aggregation_level2: "against priestly exclusivity",
    aggregation_level1: "against Church/society",
  },
  C3220: {
    id: "C3220",
    label: "bishops do not possess the Holy Spirit to ordain",
    aggregation_level2: "against priestly exclusivity",
    aggregation_level1: "against Church/society",
  },
  C2086: {
    id: "C2086",
    label: "clergy ought not to have any possessions",
    aggregation_level2: "against priestly posessions",
    aggregation_level1: "against Church/society",
  },
  C1618: {
    id: "C1618",
    label: "rejection of tithing",
    aggregation_level2: "against priestly posessions",
    aggregation_level1: "against Church/society",
  },
  C1251: {
    id: "C1251",
    label: "rejection of the Roman Church",
    aggregation_level2: "against Roman Church",
    aggregation_level1: "against Church/society",
  },
  C2091: {
    id: "C2091",
    label: "only God ought to be obeyed and not other men",
    aggregation_level2: "against social order",
    aggregation_level1: "against Church/society",
  },
  C2270: {
    id: "C2270",
    label: "rejection of oath",
    aggregation_level2: "against social order",
    aggregation_level1: "against Church/society",
  },
  C1994: {
    id: "C1994",
    label: "attacks on clergy",
    aggregation_level2: "anticlericalism",
    aggregation_level1: "against Church/society",
  },
  C1360: {
    id: "C1360",
    label: "rejection of clergy",
    aggregation_level2: "anticlericalism",
    aggregation_level1: "against Church/society",
  },
  C2098: {
    id: "C2098",
    label: "rejection of symbols of episcopal power",
    aggregation_level2: "anticlericalism",
    aggregation_level1: "against Church/society",
  },
  C1359: {
    id: "C1359",
    label: "rejection of cult",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C1101: {
    id: "C1101",
    label: "rejection of cult of martyrs",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C1100: {
    id: "C1100",
    label: "rejection of cult of saints",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C3239: {
    id: "C3239",
    label: "rejection of cult of confessors",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C2025: {
    id: "C2025",
    label: "disrespect for holy days",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C1309: {
    id: "C1309",
    label: "rejection of ecclesiastical canticles",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C1308: {
    id: "C1308",
    label: "rejection of Mass",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C1081: {
    id: "C1081",
    label: "rejection of imposition of hands",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C2043: {
    id: "C2043",
    label: "rejection of pilgrimages",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C3240: {
    id: "C3240",
    label: "preter apostolos et martyres neminem debere venerari",
    aggregation_level2: "against cult",
    aggregation_level1: "against cult",
  },
  C1061: {
    id: "C1061",
    label: "rejection of baptism as sacrament",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C1064: {
    id: "C1064",
    label: "rejection of Eucharist as sacrament",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C1113: {
    id: "C1113",
    label: "rejection of sacraments",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C1065: {
    id: "C1065",
    label: "rejection of confession as sacrament",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C1082: {
    id: "C1082",
    label: "rejection of marriage as sacrament",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C1153: {
    id: "C1153",
    label: "rejection of ordination",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C2087: {
    id: "C2087",
    label: "non est preceptum Evangelii ire ad sacerdotem pro penitentia",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C2095: {
    id: "C2095",
    label: "rejection of baptism with chrism and oil",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C2046: {
    id: "C2046",
    label: "rejection of anointing with the chrism",
    aggregation_level2: "against sacraments",
    aggregation_level1: "against cult",
  },
  C2097: {
    id: "C2097",
    label: "Eucharist can be celebrated at any place",
    aggregation_level2: "against sacred spaces",
    aggregation_level1: "against cult",
  },
  C1995: {
    id: "C1995",
    label: "attacks on church buildings",
    aggregation_level2: "against sacred spaces",
    aggregation_level1: "against cult",
  },
  C1152: {
    id: "C1152",
    label: "rejection of material churches",
    aggregation_level2: "against sacred spaces",
    aggregation_level1: "against cult",
  },
  C3427: {
    id: "C3427",
    label: "rejection of cemeteries",
    aggregation_level2: "against sacred spaces",
    aggregation_level1: "against cult",
  },
  C1054: {
    id: "C1054",
    label: "disrespect for cross",
    aggregation_level2: "antiiconism",
    aggregation_level1: "against cult",
  },
  C1310: {
    id: "C1310",
    label: "disrespect for effigies of Christ",
    aggregation_level2: "antiiconism",
    aggregation_level1: "against cult",
  },
  C2322: {
    id: "C2322",
    label: "heretical pope",
    aggregation_level2: "alternative Church ministers",
    aggregation_level1: "alternative social structure",
  },
  C2324: {
    id: "C2324",
    label: "alternative Church ministers",
    aggregation_level2: "alternative Church ministers",
    aggregation_level1: "alternative social structure",
  },
  C2325: {
    id: "C2325",
    label: "heretical bishops",
    aggregation_level2: "alternative Church ministers",
    aggregation_level1: "alternative social structure",
  },
  C2094: {
    id: "C2094",
    label: "self-proclamation as preacher",
    aggregation_level2: "alternative Church ministers",
    aggregation_level1: "alternative social structure",
  },
  C2257: {
    id: "C2257",
    label: "internal group structure",
    aggregation_level2: "alternative social structure",
    aggregation_level1: "alternative social structure",
  },
  C1073: {
    id: "C1073",
    label: "monastic alimentary restrictions",
    aggregation_level2: "alimentary restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1062: {
    id: "C1062",
    label: "fasting",
    aggregation_level2: "alimentary restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1304: {
    id: "C1304",
    label: "reduction of alcohol consumption",
    aggregation_level2: "alimentary restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1817: {
    id: "C1817",
    label: "avoidance of food originating from coition",
    aggregation_level2: "alimentary restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1066: {
    id: "C1066",
    label: "avoidance of meat",
    aggregation_level2: "alimentary restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C0800: {
    id: "C0800",
    label: "vita apostolica",
    aggregation_level2: "apostolicity",
    aggregation_level1: "asceticism/strictness",
  },
  C2299: {
    id: "C2299",
    label: "capital sin cannot be forgiven",
    aggregation_level2: "asceticism/strictness",
    aggregation_level1: "asceticism/strictness",
  },
  C1291: {
    id: "C1291",
    label: "rejection of killing",
    aggregation_level2: "killing restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1284: {
    id: "C1284",
    label: "rejection of killing animals",
    aggregation_level2: "killing restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1306: {
    id: "C1306",
    label: "rejection of money",
    aggregation_level2: "property restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C2255: {
    id: "C2255",
    label: "voluntary poverty",
    aggregation_level2: "property restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1256: {
    id: "C1256",
    label: "common property",
    aggregation_level2: "property restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1255: {
    id: "C1255",
    label: "constant prayers",
    aggregation_level2: "rules of behaviour",
    aggregation_level1: "asceticism/strictness",
  },
  C1305: {
    id: "C1305",
    label: "multiple genuflections",
    aggregation_level2: "rules of behaviour",
    aggregation_level1: "asceticism/strictness",
  },
  C2883: {
    id: "C2883",
    label: "relinquishing the world",
    aggregation_level2: "rules of behaviour",
    aggregation_level1: "asceticism/strictness",
  },
  C2884: {
    id: "C2884",
    label: "non-offensive behaviour",
    aggregation_level2: "rules of behaviour",
    aggregation_level1: "asceticism/strictness",
  },
  C2885: {
    id: "C2885",
    label: "charity",
    aggregation_level2: "rules of behaviour",
    aggregation_level1: "asceticism/strictness",
  },
  C2284: {
    id: "C2284",
    label: "importance of manual labor",
    aggregation_level2: "rules of behaviour",
    aggregation_level1: "asceticism/strictness",
  },
  C1253: {
    id: "C1253",
    label: "chastity",
    aggregation_level2: "sex/marriage restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1254: {
    id: "C1254",
    label: "endorsement of white marriage",
    aggregation_level2: "sex/marriage restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1053: {
    id: "C1053",
    label: "celibacy",
    aggregation_level2: "sex/marriage restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1816: {
    id: "C1816",
    label: "rejection of procreation",
    aggregation_level2: "sex/marriage restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C2258: {
    id: "C2258",
    label: "marriage can only be contracted between virgins",
    aggregation_level2: "sex/marriage restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C2089: {
    id: "C2089",
    label: "marriage can be annulled only in the case of adultery",
    aggregation_level2: "sex/marriage restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C1258: {
    id: "C1258",
    label: "human birth through parthenogenesis",
    aggregation_level2: "sex/marriage restrictions",
    aggregation_level1: "asceticism/strictness",
  },
  C3244: {
    id: "C3244",
    label: "cult of heresiarch",
    aggregation_level2: "cult of heresiarch",
    aggregation_level1: "cult of heresiarch",
  },
  C1623: {
    id: "C1623",
    label: "heresiarch's self-deification",
    aggregation_level2: "heresiarch's self-deification",
    aggregation_level1: "cult of heresiarch",
  },
  C1996: {
    id: "C1996",
    label: "extortion of money",
    aggregation_level2: "deception",
    aggregation_level1: "deception",
  },
  C1176: {
    id: "C1176",
    label: "feigned celibacy",
    aggregation_level2: "hypocrisy",
    aggregation_level1: "deception",
  },
  C1151: {
    id: "C1151",
    label: "feigned orthodoxy",
    aggregation_level2: "hypocrisy",
    aggregation_level1: "deception",
  },
  C1993: {
    id: "C1993",
    label: "feigned piety",
    aggregation_level2: "hypocrisy",
    aggregation_level1: "deception",
  },
  C1150: {
    id: "C1150",
    label: "in occulto",
    aggregation_level2: "secrecy",
    aggregation_level1: "deception",
  },
  C1992: {
    id: "C1992",
    label: "wandering preaching",
    aggregation_level2: "heretical practices described",
    aggregation_level1: "heretical practices described",
  },
  C2326: {
    id: "C2326",
    label: "proselytization",
    aggregation_level2: "heretical practices described",
    aggregation_level1: "heretical practices described",
  },
  C1242: {
    id: "C1242",
    label: "imposition of hands",
    aggregation_level2: "heretical practices described",
    aggregation_level1: "heretical practices described",
  },
  C3205: {
    id: "C3205",
    label: "heretical Mass celebration",
    aggregation_level2: "heretical practices described",
    aggregation_level1: "heretical practices described",
  },
  C3362: {
    id: "C3362",
    label: "conventicula hereticorum",
    aggregation_level2: "heretical practices described",
    aggregation_level1: "heretical practices described",
  },
  C3517: {
    id: "C3517",
    label: "heretical Eucharist consecration",
    aggregation_level2: "heretical practices described",
    aggregation_level1: "heretical practices described",
  },
  C1159: {
    id: "C1159",
    label: "good deeds are superfluous for salvation",
    aggregation_level2: "against deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C2042: {
    id: "C2042",
    label: "rejection of prayers for the salvation of the dead",
    aggregation_level2: "against deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C1358: {
    id: "C1358",
    label: "rejection of almsgiving for the salvation of the dead",
    aggregation_level2: "against deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C2224: {
    id: "C2224",
    label: "good deeds are superfluous for salvation of the dead",
    aggregation_level2: "against deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C1307: {
    id: "C1307",
    label: "poverty-motivated rejection of almsgiving",
    aggregation_level2: "against deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C2259: {
    id: "C2259",
    label: "rejection of mortification",
    aggregation_level2: "against deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C2422: {
    id: "C2422",
    label: "rejection of mainstream Christian cultic practices",
    aggregation_level2: "against deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C2423: {
    id: "C2423",
    label: "attitude limiting the salvatory effect of fasting",
    aggregation_level2: "against deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C2260: {
    id: "C2260",
    label: "disbelief in the existence of Purgatory",
    aggregation_level2: "against purgatory",
    aggregation_level1: "heterodox eschatology",
  },
  C1357: {
    id: "C1357",
    label: "disbelief in the resurrection of the dead",
    aggregation_level2: "against resurrection",
    aggregation_level1: "heterodox eschatology",
  },
  C2880: {
    id: "C2880",
    label: "exclusivistic ecclesiology",
    aggregation_level2: "heterodox eschatology",
    aggregation_level1: "heterodox eschatology",
  },
  C2327: {
    id: "C2327",
    label: "salvation through justice",
    aggregation_level2: "in favor of deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C2269: {
    id: "C2269",
    label: "good deeds are enough to receive the Holy Spirit",
    aggregation_level2: "in favor of deed-deserved salvation",
    aggregation_level1: "heterodox eschatology",
  },
  C2090: {
    id: "C2090",
    label:
      "children attain salvation if they die unbaptized before the age of understanding",
    aggregation_level2: "salvation of unbaptized",
    aggregation_level1: "heterodox eschatology",
  },
  C2503: {
    id: "C2503",
    label: "heterodox mariological attitude",
    aggregation_level2: "heterodox mariology",
    aggregation_level1: "heterodox mariology",
  },
  C1154: {
    id: "C1154",
    label: "antitrinitarism",
    aggregation_level2: "heterodox attitude to Trinity",
    aggregation_level1: "heterodox opinion of God",
  },
  C2323: {
    id: "C2323",
    label: "heterodox attitude to Trinity",
    aggregation_level2: "heterodox attitude to Trinity",
    aggregation_level1: "heterodox opinion of God",
  },
  C3250: {
    id: "C3250",
    label: "heterodox attitude to the Holy Spirit",
    aggregation_level2: "heterodox attitude to Trinity",
    aggregation_level1: "heterodox opinion of God",
  },
  C1080: {
    id: "C1080",
    label: "docetism",
    aggregation_level2: "heterodox christology",
    aggregation_level1: "heterodox opinion of God",
  },
  C1361: {
    id: "C1361",
    label: "rejection of Christ",
    aggregation_level2: "heterodox christology",
    aggregation_level1: "heterodox opinion of God",
  },
  C1158: {
    id: "C1158",
    label: "God did not create this world",
    aggregation_level2: "heterodox cosmogony",
    aggregation_level1: "heterodox opinion of God",
  },
  C1818: {
    id: "C1818",
    label: "sodomy",
    aggregation_level2: "debauchery",
    aggregation_level1: "malpractices",
  },
  C1177: {
    id: "C1177",
    label: "luxuria",
    aggregation_level2: "debauchery",
    aggregation_level1: "malpractices",
  },
  C1991: {
    id: "C1991",
    label: "pandering",
    aggregation_level2: "debauchery",
    aggregation_level1: "malpractices",
  },
  C1111: {
    id: "C1111",
    label: "hedonism",
    aggregation_level2: "debauchery",
    aggregation_level1: "malpractices",
  },
  C1149: {
    id: "C1149",
    label: "adoratio diaboli",
    aggregation_level2: "malpractices",
    aggregation_level1: "malpractices",
  },
  C2879: {
    id: "C2879",
    label: "idolatry",
    aggregation_level2: "malpractices",
    aggregation_level1: "malpractices",
  },
  C3246: {
    id: "C3246",
    label: "odious practices",
    aggregation_level2: "malpractices",
    aggregation_level1: "malpractices",
  },
  C2329: {
    id: "C2329",
    label: "preparedness for martyrdom",
    aggregation_level2: "martyrdom",
    aggregation_level1: "martyrdom",
  },
  C2330: {
    id: "C2330",
    label: "undergoing martyrdom",
    aggregation_level2: "martyrdom",
    aggregation_level1: "martyrdom",
  },
  C2489: {
    id: "C2489",
    label: "Donatist attitude to the efficacy of sacraments",
    aggregation_level2: "heterodox sacramental theology",
    aggregation_level1: "heterodox sacramental theology",
  },
};

export default practices;
